import React, { useEffect, useState } from 'react';
import { Empty } from 'antd';
import useSWR from 'swr';

import { useHandleSWR } from '~/libs/helpers'
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import { CenteredContainer } from '../layouts/Containers';
import useGlobalState from '~/libs/context';

const IncomesChart = (props) => {
  const { month } = props;
  const { year } = useGlobalState();
  const [ hasData, setHasData ] = useState(false);
  const [ chartData, setChartData ] = useState([]);
  const { data: swrSalesDetails } = useSWR(`/api/metrics/salesDetails?year=${year}`);
  const { data: salesDetails } = useHandleSWR(swrSalesDetails, { accounts: [] }, true);

  useEffect(() => {
    let data = [];
    let localHasData = false;
    if (salesDetails.accounts) {
      for (let acc of salesDetails.accounts) {
        const { account, months, total } = acc;
        const value = month ? months[month - 1] : total;
        if (value) {
          localHasData = true;
          data.push({ name: account.title, color: account.color, value });
        }
      }
    }
    if (hasData !== localHasData) {
      setHasData(localHasData)
      if (localHasData) {
        setChartData(data);
      }
    }
    setChartData(data);
  }, [month, salesDetails]);

  if (!hasData) {
    return <CenteredContainer style={{ height: 200 }}><Empty /></CenteredContainer>;
  }

	return (
    <ResponsiveContainer width="100%" height={200}>
      <PieChart>
        <Pie nameKey="name" dataKey="value" data={chartData} fill="#82ca9d" animationDuration={600}>
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color ?? 'gray'}/>
          ))}
        </Pie>
        <Tooltip />
        <Legend layout="horizontal" formatter={(x) => <span style={{ fontSize: 12 }}>{x}</span>} />
      </PieChart>
    </ResponsiveContainer>
	);
};

export default IncomesChart;